import { render } from "./SquadTab.vue?vue&type=template&id=b9e2bc08"
import script from "./SquadTab.vue?vue&type=script&lang=js"
export * from "./SquadTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__